import {
    Avatar,
    Box,
    Button,
    Checkbox,
    Divider,
    Drawer,
    List,
    ListItem,
    ListItemAvatar,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography,
} from '@mui/material'
import React, { ComponentPropsWithRef, Fragment, useContext } from 'react'
import BurgerIcon from '@mui/icons-material/Menu'
import MailIcon from '@mui/icons-material/MoreVert'
import Back from '@mui/icons-material/ArrowBack'

export type Anchor = 'top' | 'left' | 'bottom' | 'right'

import { BurgerButton } from './BurgerButton'
import { Assignation } from '../context/types'
import { MyChart } from './MyChart'
import { useCommonCtx } from '../context/useCommonCtx'

interface Props extends ComponentPropsWithRef<'button'> {
    toggleDrawer: (event: React.KeyboardEvent | React.MouseEvent) => void
    toggled: boolean
    anchor: Anchor
    title?: string
    assignations: Assignation[]
    showButton?: boolean
}

export const DrawerStm = (p: Props) => {
    const { className, toggleDrawer, assignations, showButton, ...rest } = p
    const orderedByRankAsc = assignations.slice() // FIXME check if copy everywhere
    const commons = useCommonCtx()

    let prevBucket: any = undefined
    const nBuckets = commons?.state?.params.assessmentParams?.['Buckets']
    // info('DrawerStm', { nBuckets, commons }) // FIXME render too much

    const list = (anchor: Anchor) => (
        <Box
            sx={{
                width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250,
                zIndex: 999999,
                height: '100vh',
                // @ts-ignore
                width: '100vw',
            }}
            role="presentation"
            onClick={toggleDrawer}
            onKeyDown={toggleDrawer}
        >
            <List>
                {['Statements'].map((text, _) => (
                    <ListItem key={text} disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                {anchor === 'left' ? <BurgerIcon /> : <Back />}
                            </ListItemIcon>
                            <ListItemText primary={text} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
            <Divider />
            <List
                dense
                sx={{
                    width: '100%',
                    bgcolor: 'background.paper',
                }}
            >
                {orderedByRankAsc.map(
                    ({ title, id, weight, bucket }, index) => {
                        // info('map', { index, id, title, weight });
                        const labelId = `checkbox-list-secondary-label-${id}`
                        const isNewBucket = prevBucket !== bucket
                        prevBucket = bucket
                        return (
                            <Fragment key={id}>
                                {isNewBucket && (
                                    <Divider
                                        sx={{ marginBottom: 3, marginTop: 3 }}
                                    >{`Bucket ${bucket}`}</Divider>
                                )}
                                <ListItem
                                    secondaryAction={
                                        <>
                                            {/* <Checkbox
                                        edge="end"
                                        disabled
                                        checked={p.array[index] !== undefined}
                                        inputProps={{
                                            'aria-labelledby': labelId,
                                        }}
                                    /> */}
                                            {bucket !== undefined && (
                                                <Typography
                                                    variant="caption"
                                                    sx={{
                                                        padding: '5px',
                                                        backgroundColor: 'red',
                                                        borderRadius: '10px',
                                                    }}
                                                >
                                                    {bucket}
                                                </Typography>
                                            )}
                                        </>
                                    }
                                    disablePadding
                                >
                                    <ListItemButton
                                        onClick={console.log}
                                    >
                                        <ListItemAvatar>
                                            {/* {index + 1}/{stmIndexes.length} [{weight}] */}
                                            {index + 1}
                                        </ListItemAvatar>
                                        <ListItemText
                                            id={labelId}
                                            primary={`${id} ${title}`}
                                        />
                                    </ListItemButton>
                                </ListItem>
                            </Fragment>
                        )
                    }
                )}
            </List>
            <MyChart assignations={assignations} nBuckets={nBuckets} />
        </Box>
    )

    return (
        <>
            {showButton && <BurgerButton onClick={toggleDrawer} title={p?.title} />}
            {/* <Button onClick={toggleDrawer(anchor, true)}>{anchor}</Button> */}
            <Drawer anchor={p.anchor} open={p.toggled} onClose={toggleDrawer}>
                {list(p.anchor)}
            </Drawer>
        </>
    )
}
